export const updatePrescriptionRequestDefault = '{\n' +
    '    "personId": "",\n' +
    '    "rxNumber": "",\n' +
    '    "profileId": "",\n' +
    '    "drugId": "",\n' +
    '    "prescriptionId": "",\n' +
    '    "authorizedQuantityPerFill": "",\n' +
    '    "authorizedTotalQuantity": "",\n' +
    '    "daysSupply": "",\n' +
    '    "daysSupplyPerFill": "",\n' +
    '    "dispenseDaysSupply": "",\n' +
    '    "dispenseQuantity": "",\n' +
    '    "expirationDate": ""\n' +
    '}';

export interface IUpdatePrescriptionRequest {
    authorizedQuantityPerFill : string,
    authorizedTotalQuantity : string,
    daysSupply : string,
    daysSupplyPerFill : string,
    dispenseDaysSupply : string,
    dispenseQuantity : string,
    drugId : string,
    personId : string,
    prescriptionId: string,
    profileId: string,
    rxNumber: string,
    expirationDate: string
}
